module.exports = __webpack_public_path__ + "static/media/buttonBG.23eaa297.png";